import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Sır alanı (api secret, token, merchant key) için ortak giriş kutusu.
 *
 * Sağlayıcı ayarlarının yarısı sırdır ve hepsi `type="password"` ile
 * yazılıyordu: yönetici yapıştırdığı 64 karakterlik anahtarın doğru gidip
 * gitmediğini göremiyor, yanlış kopyalanan bir karakter ancak bağlantı testi
 * başarısız olunca anlaşılıyordu. Göz düğmesi yalnızca **o an yazılan**
 * değeri açar; kaydedilmiş sır zaten sunucudan geri dönmez (panele maske
 * gelir), yani düğme kayıtlı bir anahtarı ifşa edemez.
 *
 * Bileşen tek yerdedir: üç ayar paneli (GameApiSettingsPanel,
 * FlexCasinoSettingsPanel, FlexGisSettingsPanel) aynı kutuyu kullanır,
 * kopyalanan bir alan bir panelde göz düğmeli, diğerinde düğmesiz kalmasın.
 */
const SecretInput = ({ className = '', ...props }) => {
  const [visible, setVisible] = useState(false);
  return (
    <span className="gc-secret">
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        className={`gc-input ${className}`.trim()}
        autoComplete="new-password"
      />
      <button
        type="button"
        onClick={() => setVisible((current) => !current)}
        className="gc-secret-eye"
        aria-label={visible ? 'Değeri gizle' : 'Değeri göster'}
        title={visible ? 'Değeri gizle' : 'Değeri göster'}
      >
        {visible ? <EyeOff size={15} /> : <Eye size={15} />}
      </button>
    </span>
  );
};

export default SecretInput;
